import { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { apiGetById } from '../../services/genesisApi/httpsMethods';
import type { LoanComp } from '../../types/deal';
import { InfoSection } from '../../components/common/infoSection';
import "../../assets/css/Text-General.css"
import { dateFormatter } from '../../utils/numberFormatter';

interface LoanCompDetailProps {
    loanCompId: number;
    isEdit: boolean;
}

const LoanCompDetail = ({ loanCompId, isEdit }: LoanCompDetailProps) => {
    const [loanComp, setLoanComp] = useState<LoanComp | null>(null);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        if (!loanCompId) return;
        apiGetById('loan-comp', loanCompId).then((response) => {
            if (response && response.success && response.data) {
                setLoanComp(response.data[0]);
            }
            setLoading(false);
        }).catch((err) => {
            console.error('Error fetching loan comp', err);
            setLoading(false);
        });
    }, [loanCompId]);

    if (loading) return <CircularProgress />;
    if (!loanComp) return <Typography>No Loan Comp found</Typography>;

    return (
        <Box sx={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        {isEdit ? (
        <Box sx={{ width: '75%', display: 'flex', gap: 1 }}>
          <Typography
            className="text-general-page-header-prefix"
            sx={{ mb: "0 !important", paddingBottom: "0 !important" }}
          >
            LOAN COMP:
          </Typography>
          <Typography
            className="text-general-page-header"
            sx={{ mb: "0 !important", paddingBottom: 0 }}
          >
            {loanComp.project_name || `#${loanComp.id}`}
          </Typography>
        </Box>
        ) : null}

        </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
                <InfoSection
                    title="Overview"
                    items={[
                        { label: 'Loan Type', value: loanComp.loan_type },
                        { label: 'Date', value: dateFormatter({ value: loanComp.date }) },
                        { label: 'Project Name', value: loanComp.project_name },
                        { label: 'Sponsor', value: loanComp.sponsor },
                        { label: 'Country', value: loanComp.country?.nicename },
                        { label: 'City', value: loanComp.city },
                        { label: 'Sector', value: loanComp.sector?.sector },
                        { label: 'Lender Type', value: loanComp.lender_type },
                        { label: 'Loan Amount (Local)', value: loanComp.loan_amount_local },
                        { label: 'LTC/LTV (%)', value: loanComp.ltc_ltv },
                        { label: 'Margin (%)', value: loanComp.margin },
                        { label: 'IRR (%)', value: loanComp.irr },
                        { label: 'Est. Local IRR (%)', value: loanComp.est_local_irr },
                        { label: 'Comment', value: loanComp.comment },
                        { label: 'Manually Validated', value: loanComp.manually_validated ? 'Yes' : 'No' },
                    ]}
                />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2, width: '100%' }}>
            </Box>
        </Box>
    );
};

export default LoanCompDetail;
